export default function (instance) {
    return {
        settings(params = {}){
            return instance.get('setting', { params })
        },
        documents(filialId){
            return instance.get('setting/documents', { params: { filial_id: filialId } })
        },
    }
}